import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../LiveLessonReseveContext';
import LiveReserveSelectInstructorModalHead from './head/LiveReserveSelectInstructorModalHead';
import LiveReserveSelectInstructorModalSelected from './selected/LiveReserveSelectInstructorModalSelected';
import LiveReserveSelectInstructorModalItem from './item/LiveReserveSelectInstructorModalItem';


function LiveReserveSelectInstructorModal(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const { instructors } = useContext(LiveReserveContext);

  const selectInst = props.selectInst;
  const setIsDispModal = props.setIsDispModal;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師の趣味・スコア情報
  const getInstDetailInfo = props.getInstDetailInfo;
  // リクエストモーダル
  const setIsDispRequest = props.setIsDispRequest;

  const listRef = useRef<HTMLDivElement>(null);
  const [listWidth, setListWidth] = useState<number>(0);


  useEffect(() => {
    if (listRef.current) {
      setListWidth(listRef.current.offsetWidth);
      // 画面リサイズにも対応したい場合
      const handleResize = () => setListWidth(listRef.current!.offsetWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const onClickRequest = () => {
    setIsDispModal(false);
    setIsDispRequest(true);
  }


  return (
    <div style={{backgroundColor: '#fff'}}>

      {/* header */}
      <LiveReserveSelectInstructorModalHead
        setIsDispModal={setIsDispModal}
      />

      {selectInst ?
        <>
          {/* 選択中 */}
          <LiveReserveSelectInstructorModalSelected
            selectInst={selectInst}
          />
        </>
      :
        <>
          {/* リクエスト */}
          <div className="text-right" style={{margin: '0 10px 5px 0'}}>
            <div
              className="btn btn-info"
              style={{padding: '5px 10px', fontSize: '80%'}}
              onClick={onClickRequest}
            >⇒ 希望講師がいない場合</div>
          </div>
        </>
      }

      {/* 一覧 */}
      <div
        ref={listRef}
        className='row'
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexGrow: 1,
          overflowY: 'auto',
          paddingRight: '5px',
          margin: 0,
        }}
      >
        {instructors && instructors.map((inst: any, index: number) => {
          const rowIndex = isPc ? Math.floor(index / 2) : index;
          const bgColor = rowIndex % 2 === 0 ? '#f8f8f8' : '#ffffff'; // 交互に色変更

          return (
            <div
              key={inst.inst_id}
              className="col-xs-12 col-sm-6"
              style={{ backgroundColor: bgColor }}
            >
              <LiveReserveSelectInstructorModalItem
                inst={inst}
                setIsDispModal={setIsDispModal}
                listWidth={listWidth}
                getInstImg={getInstImg}
                getInstDetailInfo={getInstDetailInfo}
              />
            </div>
          );
        })}
      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructorModal;